import {connectSearchBox} from "react-instantsearch-dom";
import {useTranslation} from "react-i18next";


const SearchBox = ({currentRefinement, isSearchStalled, refine}) => {
    const {t, i18n} = useTranslation();
    return (
        <div className="form__controls">
            <input
                type="search"
                value={currentRefinement}
                onChange={(event) => {
                    if (event.target.key === 'Enter') {
                        event.preventDefault();
                    }
                    refine(event.currentTarget.value)
                }}
                className="field field--larger"
                placeholder={t('Directory.SearchInput')}
            />

            <div className="form__actions">
                <button
                    onClick={(event) => refine(event.currentTarget.value)}
                    className="form__btn"
                >
                    <svg
                        version="1.1"
                        id="Layer_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 34.3 34.9"
                    >
                        <path
                            fill="#E7B940"
                            d="M34.3,33.4l-9.1-9c2.5-2.6,4-6.1,4-10c0-8-6.6-14.5-14.6-14.5C6.6,0,0,6.5,0,14.5C0,22.5,6.6,29,14.6,29
  																c3.4,0,6.6-1.2,9.1-3.2l9.2,9.1L34.3,33.4z M2,14.5C2,7.6,7.7,2,14.6,2c7,0,12.6,5.6,12.6,12.5S21.6,27,14.6,27
  																C7.7,27,2,21.4,2,14.5z"
                        ></path>
                    </svg>
                </button>
            </div>
        </div>
    )
};

const SearchInput = connectSearchBox(SearchBox);
export default SearchInput;
